import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { formatCurrency } from '@/shared/utils/general.util';

export const slugOf = (text: string) =>
	text
		.normalize('NFD')
		.replace(/[̀-ͯ]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-|-$/g, '');

export const formatPesos = (amount: number) => formatCurrency(amount, true, { decimals: 2 });

export const formatPriceWhole = (cents: number) => formatCurrency(cents, true, { decimals: 0, isInCents: true });

export const formatPesosWhole = (amount: number) => formatCurrency(amount, true, { decimals: 0 });

export const formatPeriodMonthShort = (period: string) => {
	const month = dayjs(`${period}-01`).locale('es').format('MMM').replace('.', '');
	return month.charAt(0).toUpperCase() + month.slice(1);
};

export const formatFlow = (amount: number, income: boolean) => `${income && amount >= 0 ? '+' : '−'}${formatPesos(Math.abs(amount))}`;

export const formatForeign = (amount: number) =>
	`US$${amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatRate = (rate: number) => rate.toFixed(4);

export const formatDayLong = (iso: string) => dayjs(iso).locale('es').format('dddd D [de] MMMM');

export const formatDayShort = (iso: string) => dayjs(iso).locale('es').format('D [de] MMMM');

export const formatDateFull = (iso: string) => dayjs(iso).locale('es').format('D [de] MMMM [de] YYYY');

export const formatDayMonth = (iso: string) => dayjs(iso).locale('es').format('D MMM').replace('.', '');

export const formatHour = (iso: string) => {
	const time = dayjs(iso);
	return `${time.format('h:mm')} ${time.hour() < 12 ? 'am' : 'pm'}`;
};

export const toSentenceCase = (text: string) => {
	const lower = text.trim().toLocaleLowerCase('es-MX');
	return lower.charAt(0).toLocaleUpperCase('es-MX') + lower.slice(1);
};

export const formatPeriodMonth = (period: string) => dayjs(`${period}-01`).locale('es').format('MMMM');

export const formatPeriodLong = (period: string) => dayjs(`${period}-01`).locale('es').format('MMMM YYYY');

export const sanitizeCash = (value: string) => {
	const [integer, ...decimals] = value.replace(/[^0-9.]/g, '').split('.');
	return decimals.length > 0 ? `${integer}.${decimals.join('').slice(0, 2)}` : integer;
};

export const formatCash = (raw: string) => {
	const [integer, decimals] = raw.split('.');
	const grouped = integer ? Number(integer).toLocaleString('es-MX') : '';
	return decimals === undefined ? grouped : `${grouped}.${decimals}`;
};
